import { render } from "./ComplianceHome.vue?vue&type=template&id=4490903d&scoped=true"
import script from "./ComplianceHome.vue?vue&type=script&lang=js"
export * from "./ComplianceHome.vue?vue&type=script&lang=js"

import "./ComplianceHome.vue?vue&type=style&index=0&id=4490903d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4490903d"]])

export default __exports__